import { render } from "./BulletinGrid.vue?vue&type=template&id=3fc682f4"
import script from "./BulletinGrid.vue?vue&type=script&lang=js"
export * from "./BulletinGrid.vue?vue&type=script&lang=js"

import "./BulletinGrid.vue?vue&type=style&index=0&id=3fc682f4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__